import React, { useState } from "react";
import { Container, TextField, Button, Typography } from "@mui/material";

const PointsDeductionConfigPage = () => {
  const [config, setConfig] = useState({
    onboarding: "",
    notification: "",
    conversation: "",
    warmLeadConversation: "",
    hotLeadConversation: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setConfig((prevConfig) => ({
      ...prevConfig,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(config);
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h4" gutterBottom>
        Points Deduction Configuration
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Onboarding Deduction"
          variant="outlined"
          name="onboarding"
          value={config.onboarding}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Notification Deduction"
          variant="outlined"
          name="notification"
          value={config.notification}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Conversation Cost"
          variant="outlined"
          name="conversation"
          value={config.conversation}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Warm Lead Conversation Cost"
          variant="outlined"
          name="warmLeadConversation"
          value={config.warmLeadConversation}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Hot Lead Conversation Cost"
          variant="outlined"
          name="hotLeadConversation"
          value={config.hotLeadConversation}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <Button type="submit" variant="contained" color="primary">
          Save Configuration
        </Button>
      </form>
    </Container>
  );
};

export default PointsDeductionConfigPage;
